'use client'

import { ErrorComponent } from 'monitoring/components/ErrorComponent/ErrorComponent'

export default function ErrorPage({
	error,
	reset,
}: {
	readonly error: Error & { digest?: string }
	readonly reset: () => void
}) {
	return <ErrorComponent error={error} reset={reset} />
}
